import React from "react";
import { Box, Breadcrumbs, Link, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function BreadCrumbs({ routs, component }) {
  const { t, i18n } = useTranslation();

  // Çevrilmiş metinden key'i bul
  const getKeyFromTranslated = (translatedText, lang = "en") => {
    const resources = i18n.store?.data?.[lang]?.translation;

    const recursiveSearch = (obj, prefix = "") => {
      for (const key in obj) {
        const val = obj[key];
        const fullKey = prefix ? `${prefix}.${key}` : key;

        if (typeof val === "string" && t(fullKey) === translatedText) {
          return fullKey;
        } else if (typeof val === "object") {
          const found = recursiveSearch(val, fullKey);
          if (found) return found;
        }
      }
      return null;
    };

    return recursiveSearch(resources);
  };

  const createPathFromRout = (rout) => {
    // Önce çeviri key'ini bul
    const key = getKeyFromTranslated(rout, "en");
    const slug = key ? key.split(".").pop().toLowerCase().replace(/\s+/g, "-") : null;

    // Özel case'ler (Türkçe çeviri gelse bile karşılaştırma yapılır)
    if (rout === t("airportTransfer.title")) return null;
    if (rout === t("myRequests")) return "/myrequests";
    if (rout === t("services")) return "/additional-services";
    if (rout === t("partnerRequests")) return "/myrequests";

    // Genel durum
    return `/${slug}`;
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: { xs: "flex-start", md: "center" },
      }}
    >
      <Breadcrumbs
        sx={{ mt: 1, mb: 3, minWidth: "max-content" }}
        aria-label="breadcrumb"
      >
        <Link textTransform={"capitalize"} underline="hover" color="inherit" href="/">
          {t("homePage")}
        </Link>

        {routs.map((rout, idx) => {
          const pathToCurrentRout = routs
            .slice(0, idx + 1)
            .map(createPathFromRout)
            .filter(Boolean)
            .join("");

          const isLast = idx === routs.length - 1;

          if (rout === t("airportTransfer.title")) {
            return (
              <Typography textTransform={"capitalize"} key={`${rout}-${idx}`} color="text.primary">
                {rout}
              </Typography>
            );
          }

          return isLast ? (
            <Typography textTransform={"capitalize"} key={rout} color="text.primary">
              {rout}
            </Typography>
          ) : (
            <Link
              textTransform={"capitalize"}
              key={`${rout}-${idx}`}
              underline="hover"
              color="inherit"
              href={pathToCurrentRout}
            >
              {rout}
            </Link>
          );
        })}
      </Breadcrumbs>

      {component && component !== "dashboard" ? component : null}
    </Box>
  );
}
